<template>
  <threads-nav v-show="!isSceneMode" :show-center="false" show-back>
    <template #left>
      <div class="flex items-center gap-1">
        <button class="btn btn-ghost btn-square" @click.stop="$router.back()">
          <light-arrow-icon class="text-base" />
        </button>
        <div class="flex items-center gap-1">
          <UserAvatar
            v-if="mate"
            :avatar-url="mate.mediaUrl"
            class="h-9 lg:h-10"
            @click="showMateCard = true"
          />
        </div>
        <button
          class="btn btn-ghost btn-xs lg:btn-sm btn-square"
          @click.stop="audioStore.setEnableAutoPlay(!audioStore.enableAutoPlay)"
        >
          <i
            v-if="audioStore.enableAutoPlay"
            class="iconify mingcute--volume-fill"
          ></i>
          <i v-else class="iconify mingcute--volume-mute-fill"></i>
        </button>
      </div>
    </template>
    <template #right>
      <div class="flex flex-col items-end justify-center">
        <div v-if="isPrivate" class="flex gap-1 items-center">
          <button
            v-if="currentModel?.isNsfwSupport"
            class="btn btn-ghost btn-xs flex items-center gap-1"
            @click="$router.push('/crystal#1')"
          >
            <CrystalIcon />
            {{ userStore.user.crystalQuantity }}
          </button>
          <button
            v-else
            class="btn btn-ghost btn-xs flex items-center gap-1"
            @click="$router.push('/crystal#2')"
          >
            <PowerIcon />
            {{ userStore.user.powerAmount }}
          </button>
        </div>
        <div class="text-xs">
          {{ $t("Message.restFreeChat") }}:
          {{ userStore.user.recentNsfwMessageCount }}/{{
            userStore.user.unpaidNsfwMessageMaxDaily
          }}
        </div>
      </div>
      <button
        v-if="!isLoading && isPrivate"
        class="btn btn-xs lg:btn-sm btn-ghost btn-square"
        @click="showChatSetting = true"
      >
        <i class="iconify mingcute--settings-3-line" />
      </button>
    </template>
  </threads-nav>

  <chat-setting
    v-if="mate && isPrivate && currentSession"
    v-model:show="showChatSetting"
    :session-id="currentSession.id!"
    :target-mate="mate"
  />

  <!-- 角色信息  -->
  <VanPopup v-model:show="showMateCard" position="bottom" round teleport="body">
    <div class="py-4 flex flex-col gap-4">
      <div class="font-bold px-6 text-lg">{{ mate?.name }}</div>
      <van-cell-group inset>
        <van-cell
          :label="mate?.bio || $t('Message.notBio')"
          :style="{
            '--van-cell-text-color': 'hsl(var(--s))',
            '--van-cell-label-color': 'hsl(var(--bc))',
            '--van-cell-label-font-size': '0.875rem',
          }"
          :title="$t('game.characterIntro')"
          class="text-sm"
        />
      </van-cell-group>
      <van-cell-group inset>
        <van-cell
          :title="$t('Chats.mateHome')"
          is-link
          @click="
            $router.push({
              name: 'mateHome',
              params: { uuid: mate?.uuid },
            })
          "
        >
          <template #icon>
            <div class="pr-4"><i class="iconfont icon-profile" /></div>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </VanPopup>
</template>

<script lang="ts" setup>
import { ModelList } from "@/enums/chatEnums";
import { useAudio } from "@/stores/audio";
import { useGlobalUser } from "@/stores/globalUser";
import { Mate, MateSession } from "@/types/entity";
import { computed, ref } from "vue";

const props = defineProps<{
  isSceneMode: boolean;
  mate?: Mate;
  isLoading: boolean;
  isPrivate: boolean;
  currentSession: MateSession;
}>();
const currentModel = computed(() => {
  const id = props.currentSession?.model;

  return ModelList.find((model) => model.value === id);
});
const showChatSetting = ref(false);
const showMateCard = ref(false);
const audioStore = useAudio();
const userStore = useGlobalUser();
</script>
